import type {QueryClient} from "@tanstack/react-query";

import {meService} from "../services/me";

export const ME_QUERY_KEY = ["me"] as const;

export function getMeQueryOptions() {
  return {
    queryKey: ME_QUERY_KEY,
    queryFn: () => meService.getMe(),
  };
}

/** Single /me fetch through React Query (dedupes in-flight requests). */
export function fetchMe(queryClient: QueryClient) {
  return queryClient.fetchQuery(getMeQueryOptions());
}
